const WalletIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.5 16.6667H4.5C3.39543 16.6667 2.5 15.7713 2.5 14.6667V7.83337C2.5 6.7288 3.39543 5.83337 4.5 5.83337H15.5C16.6046 5.83337 17.5 6.7288 17.5 7.83337V14.6667C17.5 15.7713 16.6046 16.6667 15.5 16.6667Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M13.75 11.6667C13.5199 11.6667 13.3334 11.4802 13.3334 11.25C13.3334 11.0199 13.5199 10.8334 13.75 10.8334C13.9801 10.8334 14.1667 11.0199 14.1667 11.25C14.1667 11.4802 13.9801 11.6667 13.75 11.6667Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 5.83333V5.10322C15 3.78916 13.7544 2.83217 12.4847 3.17075L3.98467 5.43742C3.10917 5.67089 2.5 6.46379 2.5 7.36989V7.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

export default WalletIcon;
